import {connect} from 'react-redux';
import {setQcJobsStatusesAction} from './Redux/QCJobsStatusesAction';
import {QCJobsStatusesState} from './QCJobsStatusesTypes';
import QCJobsStatusesContainer from './QCJobsStatusesContainer';

export type State = {
    qcJobs: {
        qcJobsStatuses: QCJobsStatusesState
    }
};

export const mapState = (state: State): QCJobsStatusesState => {
    const {qcJobs} = state;
    const {qcJobsStatuses} = qcJobs;
    
    return qcJobsStatuses;
};

const mapDispatch = {
    setQcJobsStatuses: setQcJobsStatusesAction,
};

export default connect(mapState, mapDispatch)(QCJobsStatusesContainer);
